export enum DiscountType {
  personalDiscount = 'personalDiscount',
  priceReductionCampaign = 'priceReductionCampaign',
}
